module.exports = __webpack_public_path__ + "img/tag_blue_pin.dea6a41e.svg";